import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({ selector: 'ngx-material-intl-tel-input', standalone: true })
export class PhoneNumberOnlyDirective implements AfterViewInit {

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    const input = this.el.nativeElement.querySelector('input[type="tel"], input:not([type="search"])');
    if (!input) return;

    input.addEventListener('keydown', (e: KeyboardEvent) => {
      const allowed = ['Backspace','Delete','Tab','Escape','Enter','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','+','-','(',')',' '];
      if (allowed.includes(e.key)) return;
      if (e.ctrlKey || e.metaKey) return; // allow Ctrl+A, Ctrl+C, Ctrl+V etc.
      if (!/^\d$/.test(e.key)) {
        e.preventDefault();
      }
    });

    input.addEventListener('paste', (e: ClipboardEvent) => {
      const pasted = e.clipboardData?.getData('text') ?? '';
      if (/[a-zA-Z]/.test(pasted)) {
        e.preventDefault();
      }
    });
  }
}
